import { stepLabel } from "../viewLabels";
import styles from "./ActivityPill.module.css";

function ActivityPill({ stepType }) {
    return (
        <div className={`${styles.pill} ${styles[stepType]}`}>
            <span className={styles.dot} />
            <span className={styles.label}>{stepLabel(stepType)}</span>
        </div>
    );
}

export default ActivityPill;
